import { VoyagePlan } from "./vessel-performance-model";

export type PAPIParamName = "sog" | "mepower" | "merpm";

export enum ParameterType
{
    SpeedOverGround, // in knots
    PropulsionPower, // in KW
    RPM
}

export interface ParameterValue
{
    timestamp: number;
    value: number;
    lower?: number;
    upper?: number;
}

export interface SimulatedParamData
{
    source: "EcoVoyage"|"Voyage"|"Excel";
    data: ParameterValue[];
}

export abstract class VoyagePerformanceModelBase extends EventTarget
{
    abstract syncData(imoNo: number, fromDate: Date, toDate: Date, plan: VoyagePlan|null): Promise<void>;
    abstract extractOneParam(type: ParameterType, onlyPositiveValues?: boolean): SimulatedParamData[];
    abstract extractOnePAPIParam(type: ParameterType, onlyPositiveValues?: boolean): ParameterValue[];
}

let VoyagePerformanceModel: VoyagePerformanceModelBase|null = null;

function setVoyagePerformanceModel(model: VoyagePerformanceModelBase)
{
    VoyagePerformanceModel = model;
}

export { VoyagePerformanceModel, setVoyagePerformanceModel };
